export default __webpack_public_path__ + "static/media/kid-football.c03e8eb5.jpg";